export enum ColumnTableType {
    ICON = 0,
    STRING = 1,
    DATE = 2,
    INSTANCEGUID = 3,
    ROUND_NUMBER_2 = 4,
    ADDRESS = 5,
    ROUND_NUMBER_5 = 6,
}

export enum HideShowColumn {
    SHOW = 0,
    HIDE_1500 = 1,
    HIDE_1000 = 2,
    SHOW_DETAILS = 3,
}

export enum SortOrder {
    ASC = "asc",
    DESC = "desc"
}